var Visibility = function () {
    var hidden = "hidden", handlers = [];
    this.isHidden = false;
    this.onChange = function(handler) {
        handlers.push(handler);
    };

    // Standards:
    if (hidden in document)
        document.addEventListener("visibilitychange", onchange);
    else if ((hidden = "mozHidden") in document)
        document.addEventListener("mozvisibilitychange", onchange);
    else if ((hidden = "webkitHidden") in document)
        document.addEventListener("webkitvisibilitychange", onchange);
    else if ((hidden = "msHidden") in document)
        document.addEventListener("msvisibilitychange", onchange);
    // IE 9 and lower:
    else if ("onfocusin" in document)
        document.onfocusin = document.onfocusout = onchange;
    // All others:
    else
        window.onpageshow = window.onpagehide =
            window.onfocus = window.onblur = onchange;

    var that = this;
    function onchange (evt) {
        var evtMap = {
            focus:false, focusin:false, pageshow:false, blur:true, focusout:true, pagehide:true
        };

        evt = evt || window.event;
        if (evt.type in evtMap)
            that.isHidden = evtMap[evt.type];
        else
            that.isHidden = this[hidden] ? true : false;

        for (var i in handlers) {
            if (handlers[i] && typeof handlers[i] == "function") {
                handlers[i](that.isHidden);
            }
        }
    }

    // set the initial state (but only if browser supports the Page Visibility API)
    if( document[hidden] !== undefined )
        onchange({type: document[hidden] ? "blur" : "focus"});
};

export default new Visibility();